import { makeAddItemsToCart } from '../../core/cart/machine/context/add-items-to-cart';
import { removeState } from '../utils/local-storage';
import { publishGiftboxAddEvent } from '../utils/analytics';
import { generateGiftboxId } from '../utils/generate-giftbox-id';
import { reloadIfOnCartPage } from '../utils/reload-if-on-cart-page';
import { assignLineToGiftBox } from '../utils/cart-line-operations';
import { MULTISTEP_FORM_LOCAL_STORAGE_KEY } from '../types';
const dispatchCartUpdate = (cart)=>{
    window.dispatchEvent(new CustomEvent('cart-drawer:update', {
        detail: cart
    }));
};
const closeModal = ()=>{
    try {
        window.dispatchEvent(new CustomEvent('modal:close', {
            detail: {
                id: 'gift-wrapping-modal'
            }
        }));
    } catch (err) {
    /* ignore */ }
};
export const submitGiftbox = async ({ contextState , giftboxProducts , diyGiftboxProducts , selectedProd , onSuccess  })=>{
    const itemsArray = Array.isArray(contextState.items) ? contextState.items : [];
    const grouped = {};
    itemsArray.forEach((unitKey)=>{
        var _String_split_;
        const lineKey = (_String_split_ = String(unitKey).split('::')[0]) !== null && _String_split_ !== void 0 ? _String_split_ : '';
        var _grouped_lineKey;
        if (lineKey) grouped[lineKey] = ((_grouped_lineKey = grouped[lineKey]) !== null && _grouped_lineKey !== void 0 ? _grouped_lineKey : 0) + 1;
    });
    // Fetch current cart to resolve line keys and properties
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();
    // Resolve giftbox variant id
    let giftboxVariantId = null;
    if (contextState.giftbox) {
        const prod = (giftboxProducts === null || giftboxProducts === void 0 ? void 0 : giftboxProducts[contextState.giftbox]) || (diyGiftboxProducts === null || diyGiftboxProducts === void 0 ? void 0 : diyGiftboxProducts[contextState.giftbox]) || null;
        if (contextState.variant) {
            giftboxVariantId = Number(contextState.variant);
        } else {
            var _prod_variants, _prod_variants_;
            giftboxVariantId = (prod === null || prod === void 0 ? void 0 : (_prod_variants = prod.variants) === null || _prod_variants === void 0 ? void 0 : (_prod_variants_ = _prod_variants[0]) === null || _prod_variants_ === void 0 ? void 0 : _prod_variants_.id) ? Number(prod.variants[0].id) : null;
        }
    }
    if (!giftboxVariantId) {
        window.dispatchEvent(new CustomEvent('gift-wrapping:error', {
            detail: {
                message: 'No giftbox selected'
            }
        }));
        return;
    }
    // DIY products skip item association and are added directly
    if (contextState.isDiy) {
        const addItemsToCart = makeAddItemsToCart();
        await addItemsToCart({
            items: [
                {
                    id: Number(giftboxVariantId),
                    quantity: 1
                }
            ]
        });
        const updatedCart = await (await fetch('/cart.js')).json();
        closeModal();
        dispatchCartUpdate(updatedCart);
        try {
            var _selectedProd_variants, _selectedProd_variants1;
            var _selectedProd_variants_find, _ref;
            const variant = (_ref = (_selectedProd_variants_find = selectedProd === null || selectedProd === void 0 ? void 0 : (_selectedProd_variants = selectedProd.variants) === null || _selectedProd_variants === void 0 ? void 0 : _selectedProd_variants.find((v)=>Number(v.id) === giftboxVariantId)) !== null && _selectedProd_variants_find !== void 0 ? _selectedProd_variants_find : selectedProd === null || selectedProd === void 0 ? void 0 : (_selectedProd_variants1 = selectedProd.variants) === null || _selectedProd_variants1 === void 0 ? void 0 : _selectedProd_variants1[0]) !== null && _ref !== void 0 ? _ref : null;
            publishGiftboxAddEvent({
                product: selectedProd,
                variant
            });
        } catch  {
        /* ignore */ }
        reloadIfOnCartPage();
        removeState(MULTISTEP_FORM_LOCAL_STORAGE_KEY);
        onSuccess();
        return;
    }
    // Add the giftbox product to cart
    const parentInstanceId = generateGiftboxId();
    var _contextState_giftboxMessage;
    const parentProperties = {
        _gift_box_id: parentInstanceId,
        _gift_box_message: (_contextState_giftboxMessage = contextState.giftboxMessage) !== null && _contextState_giftboxMessage !== void 0 ? _contextState_giftboxMessage : ''
    };
    const addItemsToCart = makeAddItemsToCart();
    await addItemsToCart({
        items: [
            {
                id: Number(giftboxVariantId),
                quantity: 1,
                properties: parentProperties
            }
        ]
    });
    // Stamp _gift_box_parent_id on each selected item.
    // When only a subset of a line item's quantity is selected, the line is split
    // so the remaining units stay as normal cart items.
    for (const lineKey of Object.keys(grouped)){
        const item = ((cart === null || cart === void 0 ? void 0 : cart.items) || []).find((it)=>it.key === lineKey);
        if (!item) continue;
        var _grouped_lineKey;
        await assignLineToGiftBox(item, (_grouped_lineKey = grouped[lineKey]) !== null && _grouped_lineKey !== void 0 ? _grouped_lineKey : 1, parentInstanceId);
    }
    const updatedCart = await (await fetch('/cart.js')).json();
    closeModal();
    dispatchCartUpdate(updatedCart);
    try {
        var _selectedProd_variants2, _selectedProd_variants3;
        var _selectedProd_variants_find1, _ref1;
        const variant = (_ref1 = (_selectedProd_variants_find1 = selectedProd === null || selectedProd === void 0 ? void 0 : (_selectedProd_variants2 = selectedProd.variants) === null || _selectedProd_variants2 === void 0 ? void 0 : _selectedProd_variants2.find((v)=>Number(v.id) === giftboxVariantId)) !== null && _selectedProd_variants_find1 !== void 0 ? _selectedProd_variants_find1 : selectedProd === null || selectedProd === void 0 ? void 0 : (_selectedProd_variants3 = selectedProd.variants) === null || _selectedProd_variants3 === void 0 ? void 0 : _selectedProd_variants3[0]) !== null && _ref1 !== void 0 ? _ref1 : null;
        publishGiftboxAddEvent({
            product: selectedProd,
            variant
        });
    } catch  {
    /* ignore */ }
    reloadIfOnCartPage();
    removeState(MULTISTEP_FORM_LOCAL_STORAGE_KEY);
    onSuccess();
};
export const submitComplimentaryMessage = async ({ message , onSuccess  })=>{
    await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            note: message
        })
    });
    const updatedCart = await (await fetch('/cart.js')).json();
    closeModal();
    dispatchCartUpdate(updatedCart);
    reloadIfOnCartPage();
    removeState(MULTISTEP_FORM_LOCAL_STORAGE_KEY);
    onSuccess();
};
